import { AlertColor } from "@mui/material";

export interface PersistentSnackbarState {
  message: string;
  type: AlertColor | undefined;
}

type Listener = () => void;

let snackbarState: PersistentSnackbarState | null = null;
const listeners = new Set<Listener>();

function emit() {
  listeners.forEach((listener) => listener());
}

/**
 * Shows a snackbar that stays on screen until the user closes it.
 *
 * Kept outside Redux so the global `setDisplayErrorSnackBar` flow - which
 * always auto-dismisses after a few seconds - is left untouched, while logic
 * files that are not React components can still raise a message.
 */
export function showPersistentSnackbar(
  message: string,
  type: AlertColor = "error",
) {
  snackbarState = { message, type };
  emit();
}

export function dismissPersistentSnackbar() {
  if (snackbarState === null) return;
  snackbarState = null;
  emit();
}

export function subscribePersistentSnackbar(listener: Listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function getPersistentSnackbar() {
  return snackbarState;
}
